const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class Terrorism extends Event {
    constructor(){
        super(
            Age.Age2,
            EventNames.Terrorism,
            "The civilization with the least culture points destroys 1 urban building of each other civilization.",
            {}
        )
    }
}

module.exports = Terrorism;